module.exports = __webpack_public_path__ + "img/parser.09aa50b4.svg";